import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { loginFormSchema, loginFormSchemaType } from '@/lib/schema';
import { router } from '@inertiajs/react';
import { Logo } from './Logo';

export function LoginForm() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<loginFormSchemaType>({
    resolver: zodResolver(loginFormSchema),
  });

  const onSubmit = async (values: any) => {
    router.post('/session', {
      email_address: values.email_address,
      password: values.password,
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-8">
      <Logo />
      <div className="flex flex-col gap-2 text-center">
        <h1 className="text-2xl font-bold">Login to your account</h1>
        <p className="text-sm text-balance text-muted-foreground">
          Enter the email and password below to login
        </p>
      </div>
      <div className="grid gap-7">
        <div className="grid gap-2">
          <Label htmlFor="email_address">Email</Label>
          <Input
            id="email_address"
            type="email"
            placeholder="johndoe@project-short.com"
            required
            {...register('email_address')}
          />
          {errors.email_address?.message && (
            <p className="text-left text-red-500">
              {errors.email_address?.message}
            </p>
          )}
        </div>
        <div className="grid gap-2">
          <div className="flex items-center">
            <Label htmlFor="password">Password</Label>
            <a
              href="/passwords/new"
              className="ml-auto text-sm underline-offset-4 hover:underline"
            >
              Forgot your password?
            </a>
          </div>
          <Input
            id="password"
            type="password"
            required
            placeholder="Enter your password"
            {...register('password')}
          />
          {errors.password?.message && (
            <p className="text-left text-red-500">{errors.password?.message}</p>
          )}
        </div>
        <Button type="submit" className="w-full">
          Sign in
        </Button>
      </div>
    </form>
  );
}
